export const codesUploadDocuments = {
  identificationCard: {
    name: 'Cédula',
    prefix: 'CC',
    code: 254
  },
  incomeCertificate: {
    name: 'Estados financieros',
    prefix: 'CI',
    code: 631
  },
  incomeStatement: {
    name: 'Declaración de renta del último año',
    prefix: 'DR',
    code: 260
  },
  workCertificate: {
    name: 'Certificación laboral',
    prefix: 'CL',
    code: 255
  },
  contractOfService: {
    name: 'Contrato de prestación de servicios',
    prefix: 'CPS',
    code: 255
  },
  payrollVouchers: {
    name: 'Último comprobante de nómina',
    prefix: 'CN',
    code: 256
  },
  pensionVouchers: {
    name: 'Último comprobante de pensión',
    prefix: 'CP',
    code: 256
  },
  financialStatements: {
    name: 'Balance y Estado P y G',
    prefix: 'EF',
    code: 259
  },
  camaraComercio: {
    name: 'Cámara de comercio',
    prefix: 'CCO',
    code: 261
  },
  rut: {
    name: 'RUT',
    prefix: 'RUT',
    code: 677
  },
  settlementResolution: {
    name: 'Resolución de liquidación',
    prefix: 'RL',
    code: 257
  }
};
